<template>
<v-container align-center>
   <!-- <NewRegistrationEdit></NewRegistrationEdit> -->
   <NewRegistrationEl></NewRegistrationEl>
</v-container>

</div>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api } from '../api.js';
import {axios, post} from 'axios';
import NewRegistrationEdit from './NewRegistrationEdit'
import NewRegistrationEl from './NewRegistrationEl'
export default {
  userName: '',
  components: {NewRegistrationEl},
  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      mode: '',
      timeout: 6000,
      snackbarText: 'Hello, I\'m a snackbar',
      output: '',
      email: 'nfn',
      password: '123456',
      clinic_id: ''

    }
  },
  methods: {
    login() {


    },
  }
}
</script>
<style scoped>
.container {
  /* height: 100vh; */
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/profileEdit.vue